'use client';

import { ToggleGroup, ToggleGroupItem } from '@eliadmin/core/src/components/ui/toggle-group';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { $t } from '@eliadmin/core/src/utils/translation-utils';

type CategorySortProps = {
  className?: string;
  selectedValue?: string;
  onSortChange?: (value: string) => void;
  searchMode?: boolean;
};

const VALUES = [
  { label: 'A → Z', value: 'name:asc' },
  { label: 'Z → A', value: 'name:desc' },
  { label: $t('text177'), value: 'price:asc' },
  { label: $t('text178'), value: 'price:desc' },
];

export function CategorySortToggleCustom(props: CategorySortProps) {
  const { t } = useTranslations();
  const categorySort = useCategorySort();
  const selectedValue = props.selectedValue ?? categorySort.selectedValue;
  const onSortChange = props.onSortChange ?? categorySort.onSortChange;

  return (
    <ToggleGroup
      type="single"
      value={selectedValue}
      onValueChange={onSortChange}
      className={cn('flex justify-start gap-1', 'ea-category-sort', props.className)}
    >
      {[
        ...(props.searchMode ? [{ label: 'Podľa relevantnosti', value: 'relevance' }] : []),
        ...VALUES,
      ].map((o) => (
        <ToggleGroupItem
          key={o.value}
          value={String(o.value)}
          className={cn(
            'data-[state=on]:pointer-events-none data-[state=on]:bg-transparent data-[state=off]:text-primary data-[state=on]:text-foreground',
            'ea-category-sort__select-item',
          )}
        >
          {t(o.label)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}

export default CategorySortToggleCustom;
